import '../style/main.sass';
import '../html/main.pug';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './comp/App.jsx';
import {store} from './redux.js';
import {Provider} from 'react-redux';

const root = document.getElementById('root');
ReactDOM.render(
	<Provider store={store}>
		<App/>
	</Provider>,
	root
);

//animation for '.anime'
root.addEventListener('scroll',() =>{
	const a = document.querySelectorAll('.anime');
	for(let i of a){
		if((i.getBoundingClientRect().top-window.innerHeight)<0){
			i.classList.add('show');
		}
	};
});